var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.76014 4.99619C5.76014 5.31276 5.63432 5.63954 5.37125 5.89484L1.55098 9.7345C1.21928 10.0613 0.658824 10.0919 0.304249 9.79577C-0.0617648 9.49963 -0.0960784 9.00946 0.235621 8.68268L3.90719 4.99619L0.224183 1.30971C-0.096079 0.982928 -0.073203 0.482547 0.292811 0.196614C0.658824 -0.0893174 1.21928 -0.0586825 1.53954 0.257886L5.38269 4.09755C5.63432 4.35284 5.76014 4.67962 5.76014 4.99619Z","fill":"black"}));
}

ArrowRight.defaultProps = {"width":"6","height":"10","viewBox":"0 0 6 10","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
